import axiosInstance from './axios-instance';

export interface AssigneePayload {
  id: number;
  accountId: number;
  name: string;
  label: string;
  roles: number[];
}

export interface AddAssigneePayload {
  accountId: number;
  name: string;
  label: string;
  roles: number[];
}

export interface EditAssigneePayload {
  accountId: number;
  id: number;
  name?: string;
  label?: string;
  roles?: number[];
  isDeleted?: boolean;
  isConverted?: boolean;
}

export interface DeleteAssigneePayload {
  accountId: number;
  id: number;
}

export interface ConvertAssigneePayload {
  accountId: number;
  assigneeId: number;
  email: string;
  canSeePricing: boolean;
  isAdmin: boolean;
}

const getAllAssigneesByAccountId = async (payload: { accountId: number }) => {
  try {
    const response = await axiosInstance.get(
      `/assignees/get-all?accountId=${payload.accountId}`
    );
    return response.data as AssigneePayload[];
  } catch (error) {
    throw error;
  }
};

const addNewAssignee = async (payload: AddAssigneePayload) => {
  try {
    const response = await axiosInstance.post('/assignees/add', payload);
    return response.data as AssigneePayload;
  } catch (error) {
    throw error;
  }
};

const editAssignee = async (payload: EditAssigneePayload) => {
  try {
    const response = await axiosInstance.put('/assignees/edit', payload);
    return response.data as AssigneePayload;
  } catch (error) {
    throw error;
  }
};

const deleteAssignee = async (payload: DeleteAssigneePayload) => {
  try {
    const response = await axiosInstance.delete(
      `/assignees/delete?accountId=${payload.accountId}&id=${payload.id}`
    );
    return response.data as { message: string };
  } catch (error) {
    throw error;
  }
};

const convertAssigneeToTeamMember = async (payload: ConvertAssigneePayload) => {
  try {
    const response = await axiosInstance.post('/assignees/convert', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export {
  getAllAssigneesByAccountId,
  addNewAssignee,
  editAssignee,
  deleteAssignee,
  convertAssigneeToTeamMember,
};
